// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyFeedOverrideWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections,
  RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections_Path,
  RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedListingAmenity,
  RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedOverrideSection,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  FeedOverrideSectionsResponseWebDto,
  GetFeedOverrideSectionsRequestDto,
  SetFeedListingAmenityRequestDto,
  SetFeedOverrideSectionRequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export type RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections_Options = UseQueryOptions<
  FeedOverrideSectionsResponseWebDto,
  unknown,
  FeedOverrideSectionsResponseWebDto,
  readonly [string, GetFeedOverrideSectionsRequestDto]
>;

const RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections_GetKey = (
  postData: GetFeedOverrideSectionsRequestDto,
) => [RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections_Path, postData] as const;

export const RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections_queryOptions = (
  postData: GetFeedOverrideSectionsRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections_GetKey(postData),
    queryFn: () => RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Return the per-section feed-override enabled state for a listing
 */
export const useRentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections = (
  postData: GetFeedOverrideSectionsRequestDto,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections_queryOptions(postData, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections.getKey =
  RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections_GetKey;

export interface RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedListingAmenity_Args {
  postData: SetFeedListingAmenityRequestDto;
}

export type RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedListingAmenity_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedListingAmenity_Args
>;

/**
 * Set or clear a boolean amenity override on a feed listing
 */
export const useRentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedListingAmenity = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedListingAmenity_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedListingAmenity_Args) =>
      RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedListingAmenity(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedOverrideSection_Args {
  postData: SetFeedOverrideSectionRequestDto;
}

export type RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedOverrideSection_Options = UseMutationOptions<
  FeedOverrideSectionsResponseWebDto,
  unknown,
  RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedOverrideSection_Args
>;

/**
 * Enable or disable feed overrides for a section of a listing
 */
export const useRentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedOverrideSection = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedOverrideSection_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedOverrideSection_Args) =>
      RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedOverrideSection(args.postData, httpClient),
  });
};
